import * as React from 'react';

import Avatar16 from './Avatar16';

export const avatar16 = () => <Avatar16 />;

export default {
    title: 'Icon/Line/Avatar16',
    component: Avatar16,
    parameters: {
        notes: "`import Avatar16 from 'box-ui-elements/es/icon/line/Avatar16';`",
    },
};
